export enum JOB_COSTING_ROUTES {
    SEARCH = '/job-costing/search',
    EXPORTJOB = '/job-costing/search/exportJobs',
    CARRIER = '/job-costing/carrier',
    EQUIPMENT = '/job-costing/equipments',
    FCR = '/job-costing/fcr',
    BOOKING = '/job-costing/booking',
    ETS = '/job-costing/ets'
}
export enum CUSTOMER_BILLING_ROUTES {
    INVOICES = '/customer-billing/issue-invoices/origin',
    CREDIT_NOTE = '/customer-billing/raise-credit-notes'
}

export enum EXCEPTION_MANAGEMENT_ROUTES {
    EXCEPTIONS = '/exception-management/exceptions',
    NOTIFICATIONS = '/exception-management/notifications',
    REPROCESS = '/exception-management/reprocess',
    CHARGE_IMPORT = '/exception-management/charge-import/import',
    CHARGE_DOWNLOAD = '/exception-management/charge-download/export',
}

export enum OTHER_ROUTES {
    UNAUTHORIZED = '/unauthorized',
    DASHBOARD = '/dashboard'
}

export enum ADMINISTRATION_ROUTES {
    EXTRA_DOCUMENT = '/administration/extra-document',
    EXTRA_DOCUMENT_EXPORT = '/administration/extra-document/export',
    MIGRATED_ESSO_RATES = '/administration/migrated-esso-rates'
}
export const MAIN_ROUTES = [
    '/job-costing',
    '/exception-management',
    '/customer-billing',
    '/administration'
]